<script>
  import { _ } from "svelte-i18n";

  export let duration = "";
  export let activity = "running";
  export let metrics = {
    calm: "",
    moderate: "",
    high: "",
  };

  const zoneConfig = [
    {
      name: "calm",
      color: "#6cea9f",
      label: $_("sessions.form.endurance.calm"),
      descriptions: $_("sessions.form.endurance.zoneDescriptions.calm"),
    },
    {
      name: "moderate",
      color: "#fff871",
      label: $_("sessions.form.endurance.moderate"),
      descriptions: $_("sessions.form.endurance.zoneDescriptions.moderate"),
    },
    {
      name: "high",
      color: "#ff8383",
      label: $_("sessions.form.endurance.high"),
      descriptions: $_("sessions.form.endurance.zoneDescriptions.high"),
    },
  ];

  let selectedZone = null; // 'calm', 'moderate', 'high', or null
  let visible = true;

  function remove() {
    visible = false;
    duration = "removed";
  }

  import { activityTypeValues, getActivityLabel } from "./activityTypes.js";
  
  const activityTypes = activityTypeValues.map(value => ({
    value,
    label: $_(`sessions.form.endurance.activityTypes.${value}`)
  }));

  function calculateTotalDuration(metrics) {
    console.log("Calculate total duration");
    const calm = parseInt(metrics.calm) || 0;
    const moderate = parseInt(metrics.moderate) || 0;
    const high = parseInt(metrics.high) || 0;
    return calm + moderate + high;
  }

  $: totalDuration = calculateTotalDuration(metrics);
  $: if (totalDuration > 0) {
    duration = totalDuration.toString();
    console.log("Duration", duration);
  }
</script>

{#if visible}
  <div class="form-subsection">
    <button
      type="button"
      on:click={remove}
      class="form-subsection__button-remove"
    >
    </button>
    <div class="endurance-content">
      <div class="form-subsection__header">
        <h4>{$_("sessions.form.endurance.title")}</h4>
      </div>

      <div class="form-group">
        <label class="select" for="activity-type">
          <span class="select__label"
            >{$_("sessions.form.endurance.activityType")}</span
          >
          <span class="select__button">
            <select bind:value={activity}>
              {#each activityTypes as activity}
                <option value={activity.value}>{activity.label}</option>
              {/each}
            </select>
          </span>
        </label>
      </div>

      <div class="form-group">
        <label class="form-label"
          >{$_("sessions.form.endurance.minutesPerZone")}</label
        >

        {#each zoneConfig as zone}
          {#if selectedZone === zone.name}
            <div
              class="info-box"
              style="background-color: {zone.color}; border: 1px solid #ddd; border-radius: 4px; padding: 12px; margin-bottom: 8px; position: relative;"
            >
              <button
                style="position: absolute; top: 8px; right: 8px; background: none; border: none; font-size: 16px; cursor: pointer;"
                on:click={() => (selectedZone = null)}>×</button
              >
              <div style="font-weight: bold; color: black;">
                {zone.label}
              </div>
              {#each zone.descriptions as line}
                <div
                  style="color: black; font-size: 14px; line-height: 1.4; margin-top: 8px;"
                >
                  {line}
                </div>
              {/each}
            </div>
          {/if}
        {/each}

        <div
          class="zone-inputs"
          style="display: flex; width: 100%; gap: 4px; box-sizing: border-box;"
        >
          {#each zoneConfig as zone}
            <div
              class="zone-group"
              style="flex: 1; min-width: 0; box-sizing: border-box;"
            >
              <div
                class="zone-column"
                style="display: flex; flex-direction: column; width: 100%;"
              >
                <div
                  class="zone-item"
                  style="display: flex; flex-direction: column; width: 100%;"
                >
                  <label
                    for="{zone.name}-minutes"
                    style="background-color: {zone.color}; color: black; border: 1px solid #ddd; height: 40px; padding: 8px; text-align: center; display: flex; align-items: center; justify-content: center; cursor: pointer; box-sizing: border-box; width: 100%;"
                    on:click={() =>
                      (selectedZone =
                        selectedZone === zone.name ? null : zone.name)}
                    >{$_("sessions.form.endurance." + zone.name)}</label
                  >
                  <input
                    id="{zone.name}-minutes"
                    type="number"
                    bind:value={metrics[zone.name]}
                    placeholder=""
                    min="0"
                    step="1"
                    on:keydown={(e) => {
                      if (e.key === "." || e.key === ",") {
                        e.preventDefault();
                      }
                    }}
                    class="form-input"
                    style="height: 36px; border: 1px solid #ddd; padding: 8px; text-align: center; margin: 0; box-sizing: border-box; width: 100%;"
                  />
                </div>
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .form-subsection {
    position: relative;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    background: #fff;
  }

  .form-subsection__button-remove {
    position: absolute;
    top: 8px;
    right: 8px;
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
    font-size: 16px;
    padding: 4px;
  }

  .form-subsection__button-remove:hover {
    color: #d32f2f;
  }

  .form-subsection__header h4 {
    margin: 0 0 16px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .form-group {
    margin-bottom: 16px;
  }

  .form-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }

  .endurance-content {
    width: 100% !important;
  }





  .form-input {
    flex: 1;
    height: 36px;
    width: 100%;
    border: 1.5px solid #ddd;
    background-color: white;
    padding: 8px;
    font-size: 14px;
    text-align: center;
    box-sizing: border-box;
    border-radius: 0;
    margin: 0;
  }

  .form-input:focus {
    outline: none;
    border-color: #2196f3;
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
  }

  .select {
    display: block;
    position: relative;
  }

  .select__label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }

  .select__button {
    position: relative;
    display: block;
  }

  .select__button::after {
    content: "";
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #666;
    pointer-events: none;
  }

  .select select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background: white;
    appearance: none;
    cursor: pointer;
  }

  .select select:focus {
    outline: none;
    border-color: #2196f3;
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
  }
</style>
